import { ref } from 'vue';

import { IFoxStudiosFloor } from '@/Core.Service.Domain/Controls/DigitalTwin/FOXStudios/types/FoxStudiosFloor.ts';

import FirstFloor from '@/Core.Service.Domain/Controls/DigitalTwin/FOXStudios/API/FOXStudios_1st_Floor/floor';

export const dialog = ref<boolean>(false);
export const childTab = ref<number>(0);

export const floors = ref<IFoxStudiosFloor[]>([{ ...FirstFloor }]);
